import enLocale from 'element-ui/lib/locale/lang/en'

const en = {
    common: {
        logout_success: 'Logout successful',
        operate_success: "Operation successful",
        operate_fail: "Operation failed",
        add_success: "Add successful",
        add_fail: "Add failed",
        save_success: "Save successful",
        system_warn: "System notification",
        ok_text: "OK",
        cancel_text: "Cancel",
        confirm_continue_text: "Confirm to continue?",
        confirm_delete_text: "Confirm to delete?",
        cancel_operate_text: "Cancelled",
        open: "Open",
        close: "Close",
        add: "Add",
        edit: "Edit",
        delete: "Delete",
        cancel: "Cancel",
        save: "Save",
        submit: "Submit",
        operation: "Operation",
        index: "Index",
        pleaseInput: "Please enter",
        pleaseSelect: "Please select",
        enable: "Enable",
        disable: "Disable",
        show: "Show",
        hide: "hide",
    },
    message: {
        menu: {
            title: "Stage Now 2.0",
            systemSettings: 'Basic Settings',
            featuredSettings: "Feature Settings",
            scanningTool: 'Scanning Settings',
            mobileButler: 'Mobile butler',
            hotKeys: "Hot keys",
            digitalCertificate: "Digital certificate",
            OtherSettings: "Other Settings",
            help: "help",
            appDesktop: "Apps and Desktop",
            Selected: "selected ",
            items: " items",
            QRCode: "QR code",
            Personalization: "Personalization"
        },
        button: {
            previewXml: "Preview Xml",
            exportXml: "Export Xml",
            previewQRCode: "Preview QRCode",
            downloadQRCode: "Download QRcode",
            resetAll: "Reset Input",
            instructions: "Instructions",
            downLoadAll: 'Download QRcode'
        },
        info: {
            QrCodeInfo: "No parameters/checklists have been configured yet. Please configure/checklists first.",
            downLoadInfo: "No QRcode has been generated yet. Please configure the parameters first.",
            pwdInfo: "Password with at least 8 digits."
        },
        // 特色配置
        featrueSettingMsg: {
            deleteConfiguration: "Delete Configuration",
            otherConfigurations: "Other configurations",
            clearConfiguration: "Clear Configuration",
            FnkeyStickingPrimaryMode: "Fn Stick Once Mode",
            shieldingP5FunctionKey: "Disable P5 key",
            shieldingP7FunctionKey: "Disable P7 key",
            touchScreenGloveMode: "Glove Mode",
            disableStatusBarDropdown: "Prohibit drop-down status bar",
            hideSoftKeyboard: "Hide the soft keyboard",
            shieldVirtualKey1: "Disable Virtual key1",
            shieldVirtualKey2: "Disable Virtual key2",
            shieldVirtualKey3: "Disable Virtual key3",
            recentToMenu: 'RECENT converts to MENU',
            shieldedHardKeyboardHOMEKey: "Shielded hard keyboard HOME key",
            shieldLockScreenKey: "Disable LockScreen key",
            prohibitedAppKey: "Disable pass scan key value to application",
            automaticallyRestart: "Automatically remove installation permissions for all apps from unknown sources after reboot",
            hardKeyboardPromptTone: "Keypad Sound",
            displayScanHoverButton: "Display a scan suspension button",
            getDeviceId: "getDeviceId() return IMEI",
            installUnknown: "Allow 'Files' app install unknown source apps",
            noDropDetection: "Disable dropping detection",
            fixedChargingMode: "Fixed charging mode",
            installAppUnknown: "Allow all app install unknown source apps",
            noPwdEnter: "You can enter the developer option without password",
            wakeUpScanKey: "Scan key wake up scan",
            wakeUpScreen: "Scan key wakes up screen",
            wakeUpDevice: "Lift to wake up the device",
            voiceKeyEnable: "Voice key enable",
            customizeFunctionKeySettings: {
                title: "Custom function key settings",
                nothing: "None",
                flashlight: "Flashlight",
                pupilLamp: "Pupil Light"
            },
            USBChargingOnly: "USB only for charging",
            supportRotation: "Support inverted rotation of the screen",
            applyCompatibilityMode: "App compatibility mode",
            focusModeEnhancement: "Scan Send By Focus Mode Enhance",
            DoubleClickWakeUpScreen: "When it is enabled, double click on the screen to wake it up"

        },
        // 移动管家
        mobileButlerMsg: {
            deleteConfiguration: "Delete Configuration",
            autoStartApp: "Self starting application",
            basicSettings: "Basic settings",
            desktopAppList: "Desktop app list",
            
            clearAllConfig: "Clear all configurations",
            clearAppConfig: "Clear application configuration",
            addApp: "Add application",
            showOnDesktop: "Show on desktop",
            accountInfo: "Account information",
            username: "Username",
            password: "Password",
            screenSaverSettings: "Screen saver settings",
            question: "Question",
            answer: "Answer",
            answerEncryptionType: "Answer Encryption Type",
            other: "Other",
            allowNewAppAdd: "Allow new apps to be added by default",
            bootStartup: "Mobile butler starts up automatically",
        },
        // 数字证书
        digitalCertificateMsg: {
            deleteConfiguration: "Delete Configuration",
            clearConfiguration: "Clear Configuration",
            deleteSignature: "Delete Signature",
            dataType: "data type",
            deleteByCertificateName: "Delete by certificate name",
            deleteByCertificateContent: "Delete according to certificate content",
            certificateNameOrCertificateContent: "Certificate name or certificate content",
            certificate: "certificate",
            certificateName: "Certificate Name",
            certificateContent: "Certificate Content"
        },
        // 热键设置
        hotKeysMsg: {
            deleteConfiguration: {
                title: "Delete Configuration",
                clearAllConfigurations: "Clear all configurations",
                clearAllMappings: "Clear All Mappings",
                clearAllBroadcasts: "Clear all broadcasts",
                deletedesignatedBroadcast: "Delete designated broadcast",
                deleteBroadcastName: "Broadcast Name",
            },
            configureBroadcast: {
                title: "Configure Broadcast",
                addBroadcast: "Add Broadcast",
                broadcastName: "Broadcast Name",
                parameter: "parameter",
                addParameter: "Add Parameter",
                name: "name",
                type: "type",
                value: "value",
            },
            keyValueMapping: {
                title: "Key Value Mapping",
                addKeyValue: "Add Key Value Mapping",
                enterPhysicalKey: "Enter Physical Key",
                mappingType: "Mapping Type",
                androidKeyValue: "Android Key Value",
                broadcastName: "Broadcast name",
                appPackageName: "App Package Name",
                appClassName: "App Class Name\n(Startup items)",
                mappingBroadcast:"BROADCAST(Mapping Broadcast)",
                mappingApp:"APPLICATION(Mapping App)",
                mappingOtherKey:"OTHER_KEYCODE(Mapping Other Key)",
                noMapping:"NONE(No Mapping)",
            }
        },
        // 扫码工具条码设置
        scanningToolMsg: {
            deleteConfiguration: "Delete Configuration",
            clearAllConfigurations: "Clear all configurations",
            clearBarcodeConfiguration: "Clear barcode configuration",
            clearApplicationConfiguration: "Clear application configuration",
            barcodeSettings: "Barcode",
            basicSettings: {
                title: "Basic settings",
                securityLevel: "Security level(0-3)",
                lighting: "Lighting",
                centeringAccuracyLevel: "aim accuracy level",
                negativeMode: "Inverse mode",
                lowPowerDelayTime: "Low power delay time(0-120)",
                Duration: "Duration",
                scanAngle: "Scanning angle",
                timeOut: "Timeout",
                securityLevel2: "Security level",
                twoWayScanning: "Bilateral scanning",
                backgroundLightIntensity: "IllumPowerLevel",
                scanDuration: "DecodeTimeout",
                adaptiveScanMode: "Aaptive Scanning",
                exposure: "Exposure Level",
                centeringMode: "PickList Mode",
                GS1: "GS1Ai Separator",
                aimPrefix: "Aim Prefix",
                inversionMode: "Inverse mode",
                aimerMode: "Aimer mode",
                sensitivityLevel: "Light level",
                scanTimeout: "Scan timeout(1-10)",
                DPMMode: "DPM Mode",
                fillLightSwitch: "ILLUMINATION",
                standardScenarios: "Standard scene",
                Scenario1: "Scene 1",
                Scenario2: "Scene 2",
                Scenario3: "Scene 3",
                multipleBarcodeReadingQuantity: "Number of barcodes per scan(0-30)",
                multiBarcodeInstantReport: "MultiBarcode Instant Reporting",
                multiBarcodeReadingDuration: "The scanning time of multiple barcodes(500-30000)",
                enhancedSoiledBarcode: "Dirty Barcode Performance Enhance",
            },
            code128: {
                minimumBarcode: "Minimum length(0-80)",
                maximumBarcode: "Maximum length(0-80)",
                ISBT128: "ISBT 128 Predefined code(N4313 optional value [0-2], others [0,1])",
                quietZone: "Quiet zone",
                negativeMode: "Inverse mode",
                normalBarcode: "only normal",
                nbrb: "normal and inverse",
                decodingRateEnhancement: "Decoding rate enhancement"
            },
            UPC: {
                transmitUPCA: "Transfer UPC-A Identifying Code",
                transmitUPCE: "Transfer UPC-E Identifying Code",
                transmitEAN13: "EAN13 check send",
                transmitEAN8: "EAN8 check send",
                UPCAPlusPrefix: "UPC-A prefixing",
                doNotAdd: "Do not add",
                addSystemCharactersOnly: "Only add the system character",
                addCountryNumber: "Add the country code and the system character",
                UPCEPlusPrefix: "UPC-E prefixing",
                UPCE1PlusPrefix: "UPC-E1 prefixing",
                convertUPCEToUPCA: "UPC-E to UPC-A",
                convertUPCE1ToUPCA: "UPC-E1 to UPC-A",
                Add5ZerosBeforeEAN8: "EAN-8 to EAN-13",
                useUCCCoupon: "Use UCC Coupon Extended Code Model",
                UPCEExtension: "UPCE Expanded",
                UPCAAdditional2: "UPC-A 2 digit add on",
                UPCAAdditional5: "UPC-A 5 digit add on",
                UPCEAdditional2: "UPC-E 2 digit add on",
                UPCEAdditional5: "UPC-E 5 digit add on",
                EAN13Additional2: "EAN13 2 digit add on",
                EAN13Additional5: "EAN13 5 digit add on",
                EAN8Additional2: "EAN8 2 digit add on",
                EAN8Additional5: "EAN8 5 digit add on",
                quietZone: "Quiet zone",
                negativeMode: "Inverse mode",
                normalBarcode: "only normal",
                nbrb: "normal and inverse",
                decodingRateEnhancement: "Decoding rate enhancement"
            },
            code39: {
                code39To32: "Code 39 to Code 32",
                addABeforeCode32: "In Code 32 and A",
                minimum: "Minimum length(0-48)",
                maximum: "Maximum length(0-48)",
                transmissionCheckCode: "Transmission codes",
                checkCode: "The inspection check code",
                code39Character: "Code 39 Start/End",
                quietZone: "Quiet zone",
                negativeMode: "Inverse mode",
                normalBarcode: "only normal",
                nbrb: "normal and inverse",
                decodingRateEnhancement: "Decoding rate enhancement"
            },
            code93: {
                minimum: "Minimum length(0-80)",
                maximum: "Maximum length(0-80)",
                quietZone: "Quiet zone",
                negativeMode: "Inverse mode",
                normalBarcode: "only normal",
                nbrb: "normal and inverse",
            },
            code11: {
                minimum: "Minimum length(1-80)",
                maximum: "Maximum length(1-80)",
                checkCode: "The inspection check code",
                transmissionCheckCode: "Transmission codes",
                twoCheckBitsAndTransmit: "2 check digits and transfer",
                oneCheckBitsAndTransmit: "1 check digits and transfer",
                twoWithoutTransmit: "2 check digits and no transfer",
                oneWithoutTransmit: "1 check digits and no transfer",
                notcheck: "0 check digits and all transfer"

            },
            Interleaved2Of5: {
                minimum: "Minimum length(2-80)",
                maximum: "Maximum length(2-80)",
                checkCode: "The inspection check code",
                transmissionCheckCode: "Transmission codes",
                staticZone: "Quiet zone",
                negativeMode: "Inverse mode",
                normalBarcode: "only normal",
                nbrb: "normal and inverse",
                null: "none",
                CheckNoTransmit: "Checked no Transmitted",
                CheckAndTransmit: "Checked and Transmitted",
                bfConvertToEAN13: "Convert to EAN13",
            },
            Discrete2Of5: {
                minimum: "Minimum length(2-60)",
                maximum: "Maximum length(2-60)",
            },
            Codabar: {
                minimum: "Minimum length(2-60)",
                maximum: "Maximum length(2-60)",
                startStopBit: "Codabar Start/Stop Code Send",
                quietZone: "Quiet zone",
                negativeMode: "Inverse mode",
                normalBarcode: "only normal",
                nbrb: "normal and inverse",
            },
            NEC2Of5: {
                minimum: "Minimum length(4-80)",
                maximum: "Maximum length(4-80)"
            },
            MSI: {
                minimum: "Minimum length(4-48)",
                maximum: "Maximum length(4-48)"
            },
            RSS: {
                restriction: "RSS Limit",
                extension: "RSS Expanded",
                RSStoUPC: "Convert RSS To UPC/EAN"
            },
            QR: {
                minimum: "Minimum length(1-7089)",
                maximum: "Maximum length(1-7089)",
                QRInverse: "QR Inverse (x3, d100 [0,1], others [0,1,2])",
                quietZone: "Quiet Zone"
            },
            DataMatrix: {
                dataMatrix: "Data Matrix",
                minimum: "Minimum length(1-3166)",
                maximum: "Maximum length(1-3166)",
                dataMatrixInverse: "Data Matrix Inverse(x3,d100[0,1],others[0,1,2])",
                never: "never",
                always: "always",
                auto: "auto",
                negativeMode: "Inverse mode",
                normalBarcode: "only normal",
                inverseBarcode: "only inverse",
                nbrb: "normal and inverse",
            },
            ChinaPost: {
                minimum: "Minimum length(4-80)",
                maximum: "Maximum length(4-80)"
            },
            Matrix2Of5: {
                Matrix2Of5minimum: "Minimum length(4-80)",
                Matrix2Of5maximum: "Maximum length(4-80)"
            },
            EANUCCComposite: {
                EANminimum: "Minimum length(1-300)",
                EANmaximum: "Maximum length(1-300)"
            },
            Composite: {
                hybrid: "UPC/EAN Composite"
            },
            PDF417: {
                PDF417minimum: "Minimum length(1-2750)",
                PDF417maximum: "Maximum length(1-2750)",
                negativeMode: "Inverse mode",
                normalBarcode: "only normal",
                nbrb: "normal and inverse",
                decodingRateEnhancement: "Decoding rate enhancement"
            },
            MicroPDF417: {
                MicroPDF417minimum: "Minimum length(1-2750)",
                MicroPDF417maximum: "Maximum length(1-2750)"
            },
            MaxiCode: {
                MaxiCodeminimum: "Minimum length(1-150)",
                MaxiCodemaximum: "Maximum length(1-150)"
            },
            Aztec: {
                Aztecminimum: "Minimum length(1-3832)",
                Aztecmaximum: "Maximum length(1-3832)",
                routine: "Convention",
                reverse: "Reverse",
                automaticDetection: "Auto detest"
            },
            CodablockF: {
                CodablockFminimum: "Minimum length(0-2048)",
                CodablockFmaximum: "Maximum length(0-2048)"
            },
            Telepen: {
                Telepenminimum: "Minimum length(1-60)",
                Telepenmaximum: "Maximum length(1-60)"
            },
            OCR: {
                OCRValue: "OCR value of the user template",
                templateSelection: "Template selection"
            }
        },
        // 扫码工具应用设置
        applySettings: {
            title: "Settings",
            generalTitle: "General Settings",
            AutoEmptying: "Auto Clear",
            startUpAuto: "Booted start",
            displayBarcodeType: "Show Type",
            filterInvisibleCharacters: "Filter invisible Char",
            convertInvisibleCharacters: "Convert invisible Char",
            characterSubstitutionSettings: "Replace String Items",
            setUp: "Settings",
            filterBarcode: "Filter pre/suffix blank",
            scanSound: "Sound",
            scanningLight: "Scan Led",
            Vibration: "Vibrate",
            barcodeAddition: "Append",
            stopScann: "Stop scan on up",
            enableScanningStatistics: "Open Scan Statistics",
            circularScanning: "Loop Scan Interval",
            intervalTime: "Interval time (ms)",
            cycleScanInterval: "Loop Scan Interval",
            MultiBarcode: "MultiBarcode",
            MultiBarcodeDisplay: "MultiCode counting display",
            barcodeSuffix: "Suffix",
            barcodePrefix: "Prefix",
            Terminator: "End Char",
            characterSet: "Charset",
            triggerMode: "Advanced trigger mode",
            ssrhs: "Manual mode",
            singleScan: "Hand-free manual mode",
            sshs: "Press for aiming;loose for scanning",
            ssdps: 'Press for aiming and press again for scanning',
            cspas: "Manual presentation mode",
            continuousLighting: "Hand-free continuous trigger mode",
            clhls: "Continuous trigger mode",
            MultiBarcodeScanning: "MultiCode",
            mbsrhr: 'MultiCode(Report on lift)',
            sendingMethod: "Mode",
            FocusEntry: "Focus",
            broadcast: "Broadcast",
            AnalogKey: "EmuKey",
            clipboard: "Clipboard",
            terminatorCase: "End char post on input",
            AutoSubmit: "Auto Submit",
            BroadcastName: "Broadcast name",
            KeyValueName: "Key name",
            startScanningBroadcast: "Action on start scan",
            stopScanningBroadcast: "Action on stop scan",
            addReturnEvent: "Default broadcast add enter event after barcode",
            scanKeyShielding: "Scan Key Block",
            userPassword: "User password (after MD5 encryption)",
            usageMode: "User Mode",
            standardMode: "Normal Mode",
            visitorMode: "Guest Mode",
            NormalMode: 'Loop Scan Interval',
            EnhancedMode: "Interval for no data",
            EnhancedModeData: "Interval for data",
            mode: "Mode",
            NormalMode1: 'Normal',
            EnhancedMode1: "Power",
            Cancel: "Cancel",
            Submit: "Confirm",
            CharacterSubstitution: "Replace String",
            SourceCharacter: "Find",
            ReplaceCharacter: "Replace",
            add: "Add",
            BarcodeSplicing: "Barcode Splicing",
            open: "On",
            close: "Off",
            index: "Index",
            operation: "Operation",
            Separator: "Separator",
            Code128: "Code 128 Splicing",
            BarcodeSuspensionSetting: "Barcode float",
            BarcodeSending: "Barcode Send Model",
            DeveloperItem: "Developer",
            Other: "Other",
            terminatorKey: "End char post on input",
            autoSubmit: "Auto Submit",
            BroadcastCustomization: "Broadcast",
            StartScanBroadcast: "Action on start scan",
            StopScanBroadcast: "Action on stop scan",
            carriageReturnTime: "Default broadcast add enter event after barcode",
            ScanKeyShield: "Scan Key Block",
            ScanKeyMask: "Scan key mask (multiple separated by commas)",
            SetUniversalPassword: "Set common password",
            GeneralPassword: "Common password",
            BarcodeTruncation: "Barcode truncation",
            StartIndex: "Start index",
            EndIndex: "End index",
            StartCharacter: "Start character",
            EndCharacter: "End character",
            CharacterMode: "Character mode",
            IndexMode: "Index mode",
            NoSeparator: "No Separator",
            Space: "Space",
            LineBreak: "Line Break"
        },
        // 基本设置
        systemMsg: {
            displaySettings: "Display setting",
            AutoBrightness: "Auto brightness",
            BrightnessPercentage: "Brightness percentage",
            SleepTime: "Sleep time",
            fifs: "15 second",
            thirtys: "30 second",
            onemin: "1 minute",
            secmin: "2 minute",
            fifmin: "5 minute",
            tenmin: "10 minute",
            thirtymin: "30 minute",
            NeverSleep: "never sleep",
            MediaVolume: "Media volume",
            soundSettings: "Sound settings",
            ringerVolume: "Ringtone volume",
            AlarmVolume: "Alarm volume",
            WiFiSettings: "Wi-Fi Settings",
            WifiManagement: "Wi-Fi management",
            WiFiSwitch: "Wi-Fi Switch",
            switchSelect: {
                null: "none",
                open: "ON",
                close: 'OFF',
                small: "Small",
                large: "Big",
                default: "Default",
                maximum: "Max",
                '001':'12h',
                '002':'24h'
            },
            NewWifiList: "Add Wi-Fi",
            WifiInformation: "WIFI information",
            selectSecurity: "Please select security",
            password: "Password",
            add: "add",
            powerSavingMode: "Power Saving Mode",
            powerSaving: "power saving",
            fullPower: "Fully functional",
            fullAttack: "Fully functional but adopt power-saving strategies during sleep",
            bandSelect: "Frequency Band",
            auto: "auto",
            fifhz: "5GHz band only",
            twohz: "2.4Hz band only",
            wifiSSID: "Wi-Fi SSID filtering rule",
            doNotRules: "No filtering rules are adopted",
            onlyWhite: "Show only white list AP",
            onlyBlack: "Show only black list AP",
            RoamingThreshold: "Roaming threshold",
            RoamingIncrement: "Roaming increment",
            WhiteList: "White list",
            blacklist: "Black list",
            MobileNetworkSettings: "Mobile network settings",
            MobileNetworkSwitch: "Mobile network switch",
            ApnName: "Name",
            agent: "Proxy",
            port: "Port",
            userName: "Username",
            OtherSettings: "Other settings",
            RemoveAllWifi: "Remove all Wi-Fi",
            Bluetooth: "Bluetooth",
            camera: "Camera",
            autoTimeZone: "Automatically determine time zone",
            autoDate: "Automatically determine date and time",
            fontSize: "Font size",
            DisplaySize: "Display Size",
            EncryptionType: "Encryption type",
            AddWifi: "Add Wi-Fi",
            EPA: "EPA method",
            Authentication: "Authentication",
            CA: "CA certificate",
            sysCertificate: "Use system certificate",
            NotVerify: "Do not verify",
            domainName: "domain name",
            identity: "identity",
            AnonymousIdentity: "Anonymous identity",
            HiddenNetwork: 'Hidden Network',
            true: "true",
            false: "false",
            Cancel: "Cancel",
            Submit: "Confirm",
            save: "save",
            index: "index",
            operation: "operation",
            addWhitelist: "Add Wi-Fi whitelist",
            addBlacklist: "Add Wi-Fi blacklist",
            UseDeviceMac: "MAC Address",
            trueUseDeviceMac: "Use device mac",
            falseUseDeviceMac: "Use random mac",
            Navabar:"Navbar",
        },
        // 其他设置
        otherSettingsMsg: {
            USBExternalStorage: "USB external storage",
            PCUSB: "PC accesses device storage via USB"
        },
        // 应用及桌面
        appDesktopMsg: {
            BlacklistApp: "Blacklist apps",
            addBlacklistApp: "Adding an Application to the Blacklist",
            BlacklistInfo: "Blacklist apps",
            appName: "app name",
            PackageName: "Package Name",
            uninstallApp: "uninstallable App",
            addUninstallApp: "Add uninstallable Apps",
            uninstallAppInfo: "Uninstallable App",
            LiveApp: "Keep alive app",
            addLiveApp: "New alive app",
            LiveAppInfo: "Keep alive app",
            desktopType: "Custom Desktop Type",
            addDesktopType: "New Desktop Type",
            desktopInfo: "Desktop Type Information",
            add: "add",
            Cancel: "cancel",
            Submit: "Confirm",
            save: "save",
            index: "index",
            operation: "operation",
            addWhitelist: "Add Wi-Fi whitelist",
            addBlacklist: "Add Wi-Fi blacklist",
        },
        // 提示信息
        messageMsg: {
            minLagermax: "The minimum length cannot be greater than the maximum length",
            strNoEmpty: "Source character cannot be empty",
            InputSSID: "Please enter ssid",
            InputSecurity: "Please select security",
            ssidNoEmpty: "ssid cannot be empty",
            save: "Please save first",
            pnNoEmpty: "packageName cannot be empty",
            normalModeTime: "Please enter the normal mode time interval",
            enhancedMode: "Please enter the enhanced mode no data interval",
            enhancedData: "Please enter the enhanced mode with data interval",
            selectOrInput: "Please select or fill in the imported package name",
            helpTitle: "Instructions",
            help1: "Stage Now configuration program is the common parameters of the device together, one-stop setup without network traffic through the scanning code, files and other forms of export copy to other devices, rapid deployment, flexible and convenient. You need to install Stage Now client - mobile device manager (itself supports direct configuration of relevant parameters, APK, support through the scanning code, Wi-Fi LAN, file export), combined with the WEB web page configuration of the relevant parameters to generate QR code, the use of mobile device manager to quickly scan the code to import.",
            help2: "1. Select parameters to configure as needed, no configuration parameters will not generate the configuration QR code; after editing the configuration information, you can save it as a configuration plan for next time use;",
            help3: "2. Because of too many configuration parameters exported QR code may be too dense and fuzzy not easy to recognize, you can choose to export the configuration items separately; due to the differences in the configuration of the models, the parameters copied to different models may be different or invalid;",
            help4: "3. Due to the differences in the configuration of models, the parameters copied to different models may be different or invalid, according to the need to configure the parameters may be changed.",
            close: "Close",
            featureMsg: " Copying and exporting the configuration items on this page to the device will only take effect for the existing parameters in the 'Feature Settings App' of the corresponding device.",
            CustomSource: "Please select or customize the source character",
            desktopMsg: "Only one custom desktop type can be added.",
            multiMag: "Please select or customize the separator",
            numBig0: "Please enter a number greater than 0",
            inputSingleChar: "Please enter a single character",
            inputEndPosition: "Please enter the end position",
            InputStartPosition: "Please enter the start position",
            sGreaterEposition: "Start position cannot be greater than end position",
            eLessSposition: "The end position cannot be less than the start position",
            inputStartChar: "Please enter the start character",
            inputEndChar: "Please enter the ending character",
            inputPackageName:"Please enter the package name",
            inputClassName:"Please enter the class name",
            inputName:"Please enter the name",
            inputAction:"Please enter the action",
            inputParameter:"Please enter the parameter",
            inputKeyName: "Please enter the key name",
            selectType:"Please select the type",
            inputVirtualKey:"Please enter the virtual key",
            complateEdit:"Please complete the editing of the current item",
            selectBroadcast:"Please select the broadcast",
            inputAppPackageName:"Please enter the app package name",
            inputAppClassName:"Please enter the app class name",
            mobileButlerTips: "The functionality of this page requires the Mobile Butler APP version to be greater than V2.0.16",
            shortCutKeyTips: "This page requires hotkey settings for app version greater than V2.2.46",
            keyMappingTips:"After successful configuration, the device needs to be restarted to take effect!",
            screenSaverTips:"In Mobile Butler, the username, password, question, answer, and answer type must all be filled in simultaneously",
        },
        // 个性化配置
        setInfo: {
            StaticIPConfiguration: "Static IP configuration",
            SingleAddition: "Single addition",
            BatchImport: "Batch Import",
            snId: "S/N",
            ipAddress: "PDA IP Address",
            mask: "Subnet Mask",
            gateway: "Gateway",
            wifiPwd: "Wi-Fi Password",
            appIpAddress: "PDA APP",
            operate: "Operate",
            update: "edit",
            delete: "delete",
            showPreview: "Preview Export",
            noteInfo: {
                sn: "Please fill in the device S/N",
                ip: "Please fill in the IP address",
                mask: "Please fill in the subnet mask",
                gateway: "Please fill in the gateway",
                dns1: "Please fill in the device DNS1",
                dns2: "Please fill in the device DNS2",
                ssid: "Please fill in the Wi-Fi SSID",
                pwd: "Please fill in the Wi-Fi password",
                app: "Please fill in the PDA APP IP address"
            },
            cancel: "cancel",
            save: "save",
            close: "close",
            export: "export",
            static: "Fill in static IP information",
            temlpate: "Please download the template and fill in the sample format strictly according to the template. The number of devices in the table should not exceed 100",
            info: 'Upload the completed information form',
            model: "Upload the completed form. If the form is not filled out as required, it may fail to upload and need to be re uploaded",
            UploadFiles: "Upload files",
            DownloadTemplate:"Download Template",
            first:"Please fill in/import IP configuration first",
            delIp:"Are you sure to delete the current IP configuration?",
            prompt:"prompt",
            ok:"OK",
            Successfully:'Successfully deleted!',
            CancelledDeletion:"Cancelled deletion",
            FileCompressionFailed:"File compression failed",
            FormatError:"File format error, please delete and upload again!",
            pleseUploadFile:"Please upload the file!",
            CurrentMandatory:"Current option is mandatory",
            EnterValue:"Please enter a valid value",
            WiFiSwitchTips:"*To set Wi-Fi related parameters, you need to turn on the Wi-Fi switch, otherwise it may cause an exception!"
        },
        // dataWedge
        dataWedge:{
            ASSOCIATED_PHYSICAL_RDBTitle:"Physical Button Scan Association",
            ASSOCIATED_PHYSICAL_RDB:'ASSOCIATED_PHYSICAL_RDB',
            VOLUP:"vol+",
            VOLDOWN:'vol-',
            VOLNOTHING:'No Association',
            NewConfigurationAdd:"New Profile",
            NewProfile:"New Profile",
            ProfileName:"profile name",
            ConfigurationFileDescription:"Description",
            EnterFileName:"Please enter the name of the configuration file",
            EnterDescription:"Please enter a configuration description",
            cancel:"cancel",
            submit:"submit",
            add:"add",
            deleteContinue:"This operation will permanently delete the configuration. Do you want to continue?",
            prompt:"prompt",
            deleteSuccess:"Delete successful!",
            cancelDelete:"Cancelled deletion",
            Application:"Application",
            AssociateApps:"Associate apps",
            AssociateAppsFile:"Associate the application with this configuration file",
            EnableConfigurationFile:"Enable profile",
            FloatingButton:"Suspension button",
            ActivateFloatingButton:"Suspension button",
            DefauleButton:"Default button display mode",
            ButtonMode:"Button mode",
            ButtonOnlyMode:"Button mode only",
            FullScreen:"Full screen mode",
            InitialPositionOfButton:"Initial button position(%)",
            TriggerScanWaitTime:"Trigger scanning waiting time",
            BarCodeInput:"BarCode input",
            SelectScanner:"Select scan engine",
            ScanningHead:"Scan engine",
            TriggerScanningMode:"Scan trigger mode",
            RaiseHandToStop:"Manual mode",
            SingleScan:"Hand-free manual mode",
            LiftHandScan:"Press for aiming &amp; loose for scanning",
            ScanWithTwoPress:"Press for aiming and press again for scanning",
            PressAgainToStop:"Manual presentation mode",
            ContinuousLightEmission:"Hand-free continuous trigger mode",
            CLRaiseHandToStop:"Continuous trigger mode",
            MultiBarcodeScanning:"MultiCode",
            ReportWithRaiseHand:"MultiCode(Report on lift)",
            ScanParameterConfiguration:"Scanning params config",
            decoder:"Decoder",
            MultipleBarcodeParameters:"Multi barcode params",
            EnableMultiBarcodeScan:"Multi barcode scanning",
            DisplayMultipleBarcodeCounts:"Show multi barcode counting",
            NumberScanEachTime:"Number of barcodes per scan",
            MultiReadTime:"Multi barcodes read time",
            MultiBarcodeSplicing:"Multi Barcode splicing",
            Disable:"Disabled",
            Enable:"Enable",
            NoDelimiter:"No Separator",
            Space:"Space",
            lineBreak:"Line Break",
            custom:"Custom separator",
            MultiBarcodeSpliceCustom:"Multi barcode splicing customization",
            ReaderParameters:"Reader params",
            CharacterSetConfiguration:"Char Set Config",
            QuasiCenterMode:"Picklist mode",
            FillLightSwitch:"Fill light",
            Exposure:"Exposure level",
            LowQualityDecoding:"Low-quality Decoding Work",
            WorkLevel1:"Working Level 1",
            WorkLevel2:"Working Level 2",
            WorkLevel3:"Working Level 3",
            ScanParameters:"Scanning params",
            ScanSound:"Sound",
            ScanVolumeType:"Scan volume type",
            UsingMediaVolume:"Media use volume",
            UsingCallVolume:"Using phone call volume",
            UsingRingtonesAndCallVolume:"Using the ring and notification volume",
            UsingAlarmVolume:"Use an alarm clock volume",
            ScanningVibration:"Scan vibration",
            ScanningPromptLight:"Scan Led",
            ScanTimeout:"Scan Time out",
            DPMMode:"DPM mode",
            KeyOutput:"Keystroke output",
            EnableButtonOutput:"Keystroke output",
            DataOutputMethod:"Data output mode",
            AnalogKey:"Emukey",
            QuickFocus:"Quickly focus",
            Clipboard:"Clipboard",
            AutomaticallyClearData:"Automatic clear data",
            BasicDataFormatting:"Basic data formatting",
            PrefixData:"Add prefix for data",
            SuffixData:"Add suffix for data",
            ConvertInvisibleCharacters:"Convert invisible char",
            SendInHexFormat:"Send as hex",
            AdvancedDataFormatting:"Advanced data formatting",
            AddRules:"Add rule",
            EnableThisRule:"Enable this rule",
            StringToCheck:"Set char to be checked",
            ApplicableBarcodeTypes:"Applicable barcode type",
            DataDeletion:"Delete char",
            DeleteLeading0:"Delete leading 0",
            FilterInvisibleCharacters:"Filter invisible Char",
            DeleteSpecifiedCharacters:"Delete specific char",
            CharacterReplacement:"Replace String",
            OriginalCharacters:"Find",
            ReplaceCharacters:"Replace",
            BarcodeCapture:"Intercept char",
            StartingInPositionalOrder:"Start in positional order",
            LeftNumberPosition:"Num of start position",
            EndInPositionalOrder:"End in positional order",
            LeftEndOrder:"Num of end position",
            StartingWithSingleCharacter:"Starting with a single character",
            StartSpecificCharacter:"Start with specific single char",
            EndWithSingleCharacter:"End with a single character",
            EndWithSpecificSingleCharacter:"End with specific single char",
            EndCharacter:"End character",
            IntentOutput:"Intent output",
            EnableIntentOutput:"Intent output",
            BroadcastAction:"Broadcast action",
            BroadcastDataLabel:"Broadcast data labels",
            IPOutput:"IP output",
            EnableIPOutput:"IP output",
            IPAddress:"IP address",
            Port:"Port",
            NewRule:"New rule",
            RuleName:"ruleName",
            EnterRuleName:"Please enter the rule name",
            save:"save",
            delete:"delete",
            set_spec_s_inter:"Set the char to be intercepted",
            set_spec_s_replace:"Set the char to be replaced",
            set_spec_s_end:"Set end char",
            code_intercept:"Intercept char",
            end_str:"End char",
            replace_string_title:"Replace String",
            success:"success",
            set_spec_s_del:"Set the char to be deleted",
            data_delete:"Delete char",
            WhetherDelete:"Whether to delete the rule",
            Tips:"Tips",
            AlreadyRemoved:"Delete completed",
            DeleteCanceled:"Delete canceled",
            subPackage:"Explanation: package name and sub-package name should be filled in, sub-package name is activity page, if all activity pages are effective, then add * after the sub-package name, if part of it is effective, then use English comma to separate the sub-package name (page activity). Example: fill in com.android.chrome as the package name, fill in com.android.chrome* as the sub-package name for all active pages, and fill in as many sub-packages as needed for partially active pages and use comma to separate them.",
            AddedAppPackage:"Added an application package",
            PackageName:"Package name",
            SubpackageName:"Subpackage name",
            del_config_file:"General params configuration file by default",
            scandemo_pa_set:"Scan Demo params setting",
            alre_ex_name:"Existing configuration that name!",
            RequiredRuleName:"Please input rule name",
            orderValues:"Please do not repeat the order values",
            order:"order",
            Select:"Select",
            AutoSubmit:'Auto Submit',
            BasicSettings:"Basic Settings",
            EnableLogging:"Log",
            administratorMode:"Admin mode",
            AdminPassword:"Admin password",
            DeveloperMode:"Developer mode",
            dev_bc_start_scan:"Action on start scan",
            dev_bc_stop_scan:"Action on stop scan",
            admin_pass:"Admin password",
            confirmPass:"Confirm password",
            set_admin_pass:"Set admin password",
            confirm_pass:"Confirm password again",
            EnterAdminPwd:"Please enter admin password",
            hint_password_not_same:"*Password input is inconsistent!!",
            data_wedge_set:"Data Wedge set",
            scan_key_248_block:"Disable Scan Key 248",
            scan_key_249_block:"Disable Scan Key 249",
            scan_key_250_block:"Disable Scan Key 250",
            scan_key_block_title:"Scan Key Block",
            dataTips:"*The scan code configuration function on this page requires a Data wedge version greater than V1.1.3.",
            isEndCharOnEmu:'The terminator is transmitted via button press',
            BarcodeFiltering:'Barcode filtering',
            '001':'By barcode type',
            '002':'Output barcode',
            '003':'Do not output barcode',
            '004':'Barcode type',
            '005':'By barcode length',
            '006':'Barcode length',
            '007':'If you choose not to output barcodes, the displayed barcode data will not be output according to the configured rules for each scan.',
            '008':'Please select barcode type',
            '009':'Please fill in the barcode length',
            numberOnlyWarning:"Please enter the numerical type",

        }
    },
    messageAdd:{
        mainPage:{
            versionMsg:"Stage Now2.0 mobile client version (mobile device manager) must be greater than 5.0.0 or above, below this version, please enter the",
            oldVersion:"Stage Now",
            login:'Login',
            unlogin: 'Exit',
            '001':"Configuring Device Params",
            '002':'My Config Options',
            '003':'Common Params',
            '004':"Deact functions",
            '005':"Custom Config",
            '006':'Saved Config',
        },
        common:{
            '001':'Wi-Fi setup',
            '002':'Mobile Network Settings',
            '003':'Launcher Settings',
            '004':'Display Settings',
            '005':'Sound Settings',
            '006':'Time Setting ',
            '007':'USB settings',
            '008':'General Settings',
            '009':'FeatureSettings',
            '010':'ScanTool',
            '011':'Mobile Butler',
            '012':'ShortCut Settings',
        },
        wifi:{
            '001':'* If this configuration is turned on, adding a new Wi-Fi list will be disabled',
            '002':'Wi-Fi black and white list',
            '003':'black-white list strategy',
            '004':'No Filter Control',
            '005':'SSID whitelist',
            '006':'SSID blacklist',
            '007':'Wi-Fi information has been saved successfully',
            '008':'Form validation failed, please check the fill in content',
            '009':'Please save the data first',
        },
        time:{
            '001':'Time Setting',
            '002':'Time Display Setting',
        },
        scanTool:{
            '001':'Barcode Setup',
            '002':'Application Setup',
            '003':'The start/end position cannot be empty',
            '004':'The start/end character cannot be empty'
        },
        mobile:{
            '001':'Mobile Network Management'
        },
        launcher:{
            '001':'Launcher Settings',
            '002':'Customized launcher',
            '003':'Please fill in the package name first',
            '004':'Please save the data first',
            '005':'Please fill in the data first'
        },
        display:{
            '001':'Display Settings',
            '002':'Wallpaper Settings',
            '003':'Manage Wallpaper',
            '004':'Select Server',
            '005':'External download path',
            '006':'External Link',
            '007':'Stage Now Server',
            '008':'Upload Files',
            '009':'Select file',
            '010':'Upload Server',
            '011':'Invalid file format, only .png and .jpg are supported!',
            '012':'File size cannot exceed 10MB!',
            '013':'Please select a file first',
            '014':'Please upload the file to the server first',
            '015':'Only one file can be uploaded',
            '016':'Please enter the file address first',
        },
        custom:{
            '001': 'Select configuration item',
            '002': '(Please select an appropriate number of configuration items, selecting too many will increase the number of generated configuration codes)',
            '003': 'Operation',
            '004': 'Configuration item',
            '005': 'Introduction',
            '006':'Select',
            '007':'Selected ',
            '008':'Clear',
            '009': '* Long press to move order',
            '010': 'Cancel',
            '011': 'Confirm',
            '012': 'Wi-Fi Settings',
            '013': 'Wi-Fi related parameter settings',
            '014': 'Manage file certificates',
            '015': 'Manage and configure file uploads, Wi Fi certificates, etc.',
            '016': 'Display Settings',
            '017': 'Screen brightness, font size, sleep time, etc.',
            '018': 'MobileNetwork Settings',
            '019': 'MobileNetwork related parameter settings',
            '020': 'Common Settings',
            '021': 'Bluetooth switch, GPS switch, NFC switch, camera switch disable notification and other settings',
            '022': 'launcher Settings',
            '023': 'Default desktop, wallpaper, custom desktop settings, etc.',
            '024': 'Sound Settings',
            '025': 'Set ringtone volume, media volume, etc.',
            '026': 'Time Settings',
            '027': 'Set time format, time zone, determine network time, etc.',
            '028': 'USB settings',
            '029': 'Set USB external storage, ADB switch, etc.',
            '030': 'Manage Applications',
            '031': 'Application download and application blacklist, keep alive, anti uninstall and other application management',
            '032': 'Featured Settings',
            '033': 'Call the feature settings app to configure features such as disabling status bar dropdown, hiding soft keyboard, blocking virtual keys, installing unknown source applications, etc.',
            '034': 'ScanTool',
            '035': 'Call the scanning tool APP to configure scanning related parameters',
            '036': 'Call the Data Wedge APP (installation required), configure scanning parameters, scanning scheme and other parameters',
            '037': 'This page has been added! Please do not add again!',
            '038': 'Please add at least one page!',
            '039':'Current configuration cleared',
            '040':'Custom config mode',
            '041':'No params configured yet, please configure them first',
            '042':'Mobile Butler',
            '043':'Call the Mobile Butler APP to configure custom desktop and manage desktop-visible apps, set passwords, enable auto-start, etc.',
            '044':'Hotkey Settings',
            '045':'Call the Hotkey Settings APP (installation required) to quickly configure the corresponding functions mapped to each physical key',
        },
        deact:{
            '001': 'Deact functions',
            '002': '*This page allows you to disable, block, or restore commonly used system functions. Please exercise caution as these operations may impact the normal use of the device. When scanning the generated QR code with the client app, a password will be required. Note: Factory reset-related disablement/block configurations will remain effective, and to use these features, the mobile client version must be 5.0.3.5 or higher.',
            '003': 'General Settings',
            '004': 'Configure password:',
            '005': 'Restore use of all functional items:',
            '006':'QR code validity period:',
            '007': 'Start date',
            '008':'End Date',
            '009':'to',
            '010': 'Restoring factory configuration still takes effect:',
            '011': 'System Function Item',
            '012': 'Wi-Fi function:',
            '013': 'SIM card function:',
            '014': 'Call&SMS function:',
            '015': 'Network APN settings:',
            '016': 'Flight mode:',
            '017': 'SMS function:',
            '018': 'Bluetooth function:',
            '019': 'GPS positioning function:',
            '020': 'Camera Features:',
            '021': 'NFC function:',
            '022': 'External SD card:',
            '023': 'Soft keyboard:',
            '024': 'Fixed USB Usage:',
            '025': 'USB debugging function:',
            '026': 'Disable system function item',
            '027': 'The current page parameters have been reset',
            '028': 'Parameters have not been configured yet, please configure them first',
            '029': 'Data error occurred',
            '030': 'Please fill in the configuration password',
            '031': 'Prohibited Use',
            '032': 'Restore Use',
            '033': 'File Transfer',
            '034': 'USB network sharing',
            '035': 'MIDI',
            '036': 'PTP',
            '037': 'No data transmission',
            '038': 'Flight mode normally on',
            '039': 'Turn off airplane mode and keep it on',
            '040': 'Can only input numbers, uppercase and lowercase English and characters, with a maximum length of 15 digits',
            '041': 'USB enable/disable (connect to PC)',
            '042': 'Activate flight mode and lock',
            '043': 'Turn off airplane mode and lock',
            '044': 'Clear lock and activate airplane mode',
            '045': 'Clear lock and turn off flight mode',
            '046': "If the device is factory pre-installed with Mobile Device Manager, this feature will be disabled. Customized mobile editions should not utilize this functionality. After performing a factory reset, the device must be restarted or the 'Mobile Device Manager' must be launched for the functionality to take effect.",
            '047': 'Open and lock',
            '048': 'Close and lock',
            '049': 'Clear lock and enable',
            '050': 'Clear lock and close',
            '051': 'WLAN hotspot',
        },
        manageApp:{
            '001': 'App Download',
            '002': 'App download list:',
            '003': 'Validity:',
            '004': 'to',
            '005': 'Start date',
            '006':'End Date ',
            '007':'Number ',
            '008':'Get Server ',
            '009': 'External path',
            '010': 'Stage Now Server',
            '011': 'Download Path',
            '012': 'AppName',
            '013': 'Version',
            '014': 'Device storage path',
            '015': 'High&low version',
            '016': 'Keep high version',
            '017': 'Force overwrite installation',
            '018': 'After download',
            '019': 'Automatically install and start',
            '020': 'Automatic installation does not start',
            '021': 'Download only, do not install',
            '022': 'Startup mode',
            '023': 'Start App',
            '024': 'Specify activity',
            '025': 'Specify service',
            '026': 'Startup className',
            '027': 'Set as initiator',
            '028': 'Yes',
            '029': 'No',
            '030': 'Operation',
            '031': 'Delete',
            '032': 'Edit',
            '033': 'APP uninstallation',
            '034': 'Uninstall App List:',
            '035': 'APP disable',
            '036': 'APP cache cleaning',
            '037': 'Clean up cache app list:',
            '038': 'Uninstall Application List',
            '039': 'Disable App List:',
            '040': 'Clean up cache app list:',
            '041': 'Download path',
            '042': 'Select Server',
            '043': 'Upload apk',
            '044': 'Select file',
            '045': 'Upload to server',
            '046': 'App name',
            '047': 'Version',
            '048': 'Startup class name',
            '049': 'Set as initiator',
            '050': 'Please select type',
            '051': 'Please enter the download path',
            '052': 'Please enter the app name',
            '053': 'Please fill in the version',
            '054': 'The file is currently being uploaded, please wait a moment',
            '055': 'Successfully uploaded to server',
            '056': 'Do you want to set the current data as a startup item?',
            '057': 'Prompt',
            '058': 'OK',
            '059': 'Cancel',
            '060': 'Please upload the file to the server first',
            '061': 'Do you want to delete the current configuration information?',
            '062': 'Delete successfully!',
            '063': 'Deletion canceled',
            '064':'Select Server',
            '065':'Description:Select Stage Now server only support APK format, each upload no more than 10, each file size no more than 200M.If you need to use it often, you can save it as a program for subsequent use, in which the APK file can be saved for 6 months, and will be deleted automatically after the expiration date.',
            '066': 'PackageName cannot be empty',
        },
        manageCert:{
            '001': 'Manage Files',
            '002': 'File Download',
            '003': 'File download path:',
            '004': 'Validity:',
            '005': 'to',
            '006':'Start date ',
            '007': 'End Date',
            '008':'Serial Number ',
            '009': 'Get Server',
            '010': 'External download path',
            '011': 'Stage Now Server',
            '012': 'File name',
            '013': 'File type',
            '014': 'Download Path',
            '015': 'Device storage path',
            '016': 'Operation',
            '017': 'Edit',
            '018': 'Delete',
            '019': 'File deletion',
            '020': 'Need to delete file path:',
            '021': 'Management Certificate',
            '022': 'Wi-Fi cert download',
            '023': 'Cert download path:',
            '024': 'Cert file name',
            '025': 'Install after successful download',
            '026': 'Yes',
            '027': 'No',
            '028': 'Installation password',
            '029': 'Cert installation',
            '030': 'Cert installation path required:',
            '031': 'Cert removal',
            '032': 'Cert information needs to be removed:',
            '033': 'Path of file to be deleted',
            '034': 'Path of file in device',
            '035': 'Name of certificate file to be removed',
            '036': 'Cert file name',
            '037': 'Cert path to be installed',
            '038': 'Path of cert in device',
            '039': 'File download path',
            '040': 'Select Server',
            '041': 'Upload file',
            '042': 'Select file',
            '043': 'Upload to server',
            '044': 'Cert download path',
            '045': 'Please select type',
            '046': 'Please enter the download path',
            '047': 'Please enter the file name',
            '048': 'Please enter file type',
            '049': 'The file is currently being uploaded, please wait a moment',
            '050': 'Successfully uploaded to server',
            '051': 'Please upload the file to the server first',
            '052': 'Do you want to delete the current configuration information?',
            '053': 'Prompt',
            '054': 'OK',
            '055': 'Cancel',
            '056': 'Delete successfully!',
            '057': 'Deletion canceled',
            '058':'The path cannot be empty',
            '059':'The file size cannot exceed 50MB!',
            '060':'Up to 10 files can be uploaded',
            '061':'The file size cannot exceed 5MB!',
            '062':'Up to 30 files can be uploaded',
            '063':'The file size cannot exceed 200MB!',
            '064':'The certificate file name cannot be empty',

        },
        saveConfig:{
        '001': 'Scheme List',
        '002': 'Scheme Name',
        '003': 'Scheme type',
        '004': 'Config common params',
        '005': 'Deact function items',
        '006':' Custom Config Mode ',
        '007': 'CreateTime',
        '008':' View Config ',
        '009': 'Config code',
        '010': 'Delete',
        '011': 'QRCode Preview',
        '012': 'Do you want to delete the current configuration item?',
        '013': 'Prompt',
        '014': 'Confirm',
        '015': 'Cancel',
        '016': 'Delete successfully!',
        '017': 'Deletion canceled',
        '018':'Operation',
        '019':'This operation will override the current parameter configuration, do you want to continue?',
        '020':'If there are parameters being configured on other pages, viewing the saved configuration will clear the parameters being configured on the corresponding page.'
        },
        app:{
            '001': 'SelectMode',
            '002': 'setIntervalTime',
            '003': 'IntervalTimeNoData',
            '004': 'IntervalTimeData',
        },
        general:{
            '001': 'General Settings',
            '002': 'System shortcut',
            '003': 'Bluetooth:',
            '004': 'GPS:',
            '005': 'NFC:',
            '006':'Camera: ',
            '007':'Other settings',
            '008':'System language: ',
            '009': 'Message notify:',
            '010':'Chinese', 
            '011':'English',
            '012':'Virtual Navigation Bar',
            '013':'System Security Mode',
        },
        appSet:{
            '001':'Data saved',
            '002':'Please configure parameters first',
            '003':'Normal Mode - Cyclic Scanning Interval Data must exist and be numeric',
            '004':'Please check the currently filled data',
        },
        note: {
            '001':'Current configuration cleared',
            '002':'No parameters have been configured yet, please configure them first',
            '003':'Please Login',
            '004':'Hidden virtual navigation bar only supports Android14 system',
            '005': 'Support file formats: .png, .jpg, no more than 10M. Please create and upload pictures of corresponding resolutions according to the device model. After confirmation, it will be set as the default desktop wallpaper. ',
        }
    },
    code: {
        'DA0200': 'User login exception',
        'DA0230': 'User login has expired',
        'DA0231': 'User not logged in',
        'DA0301': 'Unauthorized access',
        'DA0400': 'User request parameter error',
        'DA0402': 'Invalid user input',
        'DA0410': 'Request required parameter is empty',
        'DA0420': 'Request parameter value exceeds allowed range',
        'DA0421': 'Parameter format mismatch',
        'DA0501': 'Request frequency exceeds limit',
        'DA0700': 'User uploading file exception',
        'DA0701': 'User uploaded file type does not match',
        'DA0702': 'User uploaded file too large',
        'DA0706': 'Too many files uploaded by the user',
        'DA0707': 'File binding failed',
        'DA0708': 'The total size of files uploaded by the user exceeds the limit',
        'DA1100': 'User does not have data query permission',
        'DA1101': 'No data',
        'DA1200': 'User does not have permission to delete data',
        'DA1300': 'User does not have permission to modify data',
        'DB0001': 'System execution error',
        'DB0324': 'File download failed',
        'DC0001': 'Error calling third-party service',
        'DC0300': 'Database service error',
    },
    componentMsg:{
        '001': 'Language',
        '002': 'Reset this page',
        '003': 'Save as Plan',
        '004': 'Preview QRCode',
        '005': 'Export QRCode',
        '006': 'Export config file',
        '007': 'Do you want to clear the current page configuration parameters?',
        '008':'Prompt',
        '009': 'Confirm',
        '010': 'Cancel',
        '011': 'Deletion canceled',
        '012': 'Save as Plan',
        '013': 'SchemeName',
        '014': 'SchemeType',
        '015': 'Config common parameters',
        '016': 'Disable system function item',
        '017': 'Custom Config Mode',
        '018': 'Please enter the schemeName',
        '019': 'Scheme saved successfully',
        '020': 'QRCode Preview',
        '021':'Preview Configuration File',
    },
    ...enLocale
}

export default en;